<template>
    <div id="lt-yantr" class="loan-amount-calculator">
        <div class="mortgage-heading">
            <div class="mortgage-amount-title">{{ headline }}</div>
            <div class="mortgage-amount">{{ displayAmount() }}</div>
        </div>
        <div class="vue-slider-block">
            <vue-slider
                v-model="LoanAmount"
                :max="loanAmtSlider.max"
                :min="loanAmtSlider.min"
                :clickable="loanAmtSlider.clickable"
                :interval="loanAmtSlider.interval"
                @dragging="formatLoanAmtVal($event.currentValue)"
            />
        </div>
        <button class="btn btn-blue" type="submit" @click="redirectToDestination()">{{ DestinationButtonText }}</button>
        <div class="clear-fix"></div>
        <div class="disclosure-term">
            <advertising-disclosures v-if="isToShowDisclosureLink()" :disclosure-text="DisclosureText" :disclosure-tokens="DisclosureTokens" />
            <span v-if="isToShowDisclosureLink()" class="optional-line">|</span>
            <div v-if="DisplayTermsAndConditions" class="terms">{{ termsAndConditions }}</div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import vueSlider from 'vue-slider-component';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import BaseMixin from '~/mixin/base-mixin';

    export default {
        props: {
            headline: {
                default: 'What Mortgage Amount Do You Need?',
            },
            loanAmount: {
                default: 225000,
            },
            minValue: {
                default: 0,
            },
            maxValue: {
                default: 1000000,
            },
            stepValue: {
                default: 25000,
            },
            isHighestValue: {
                default: true,
            },
            destinationButtonText: {
                default: 'Calculate Payment',
            },
            disclosureText: {
                default: 'Disclosure',
            },
            destinationLinkOrId: {
                default: 'wp-mortgage',
            },
            disclosureTokens: {
                default: '00093',
            },
            displayDisclosureText: {
                default: false,
            },
            termsAndConditions: {
                default: 'Terms & Conditions apply. NMLS#1136',
            },
            displayTermsAndConditions: {
                default: 'true',
            },
            destinationQuery: {
                default: null,
            },
        },
        data: function data() {
            return {
                LoanAmount: this.loanAmount,
                MinValue: parseInt(this.minValue, 10),
                MaxValue: parseInt(this.maxValue, 10),
                StepValue: parseInt(this.stepValue, 10),
                loanAmtSlider: {
                    clickable: true,
                    min: parseInt(this.minValue, 10),
                    max: parseInt(this.maxValue, 10),
                    interval: parseInt(this.stepValue, 10),
                },
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                TermsAndConditions: this.termsAndConditions,
                DisplayTermsAndConditions: this.displayTermsAndConditions === 'true',
                DestinationQuery: this.destinationQuery,
            };
        },
        methods: {
            formatLoanAmtVal() {
                this.LoanIntAmount = this.LoanAmount;
                this.LoanAmount = Accounting.formatMoney(this.LoanAmount, { symbol: '$', precision: 0 });
                this.displayAmount();
            },
            isToShowDisclosureLink() {
                if (this.DisclosureText && (this.displayDisclosureText === 'true' || this.displayDisclosureText.toString().toLowerCase() === 'true')) {
                    return true;
                }

                return false;
            },
            displayAmount() {
                this.LoanIntAmount = this.LoanAmount;
                let amount = Accounting.formatMoney(this.LoanAmount, { symbol: '$', precision: 0 }).toString();
                if (this.isHighestValue && this.isHighestValue.toString().toLocaleLowerCase() === 'true' && this.LoanIntAmount === this.loanAmtSlider.max) {
                    amount = `${amount.toString()}+`;
                }
                return amount;
            },
            redirectToDestination() {
                this.DestinationLinkOrId = `${this.destinationLinkOrId}&amount=${this.LoanAmount}`;
                if (this.destinationQuery !== null) {
                    const queryParam = this.destinationQuery.replace(/<\/?span[^>]*>/g, '');
                    this.DestinationLinkOrId = `${this.DestinationLinkOrId}&${queryParam}`;
                }
                this.redirect();
            },
        },
        mixins: [BaseMixin],
        components: {
            vueSlider,
            AdvertisingDisclosures,
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
